import React, { useState } from "react";
import Sidebar from "./SideBar/SideBar";
import BookingTable from "./Booking/BookingTable";
import CustomerTable from "./Customer/CustomerTable";
import BookingReportDashboard from "./Reports/BookingReportDashboard";
import Dashboard from "./Dashboard/Dashboard";
import TableManagement from "./Table/TableManagement";
import Settings from "./Setting/Settings";
import "./css/generals.css";
import "./css/AdminDashBoard.css";
import UserManagement from "./UserManagement/UserManagement";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../api/authApi";
import BookingCalendar from "./BookingCalendar/BookingCalendar";
import { useTranslation } from "react-i18next";

const AdminDashBoard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation()
  const [activeView, setActiveView] = useState("dashboard");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMenuSelect = (menuId) => {
    setActiveView(menuId);
    // Close mobile menu when item is selected
    setIsMobileMenuOpen(false);
  };

  const handleNavigateToBookings = (filter = null) => {
    setActiveView("bookings");
  };

  const handleNavigateToCustomers = (filter = null) => {
    setActiveView("customers");
  };
  
  const handleNavigateToTables = () => {
    setActiveView("tables");
  };

  const handleLogout = () => {
    if (window.confirm(t('admin.logout_confirm'))) {
      logout();
      navigate("/signin");
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const renderContent = () => {
    switch (activeView) {
      case "dashboard":
        return (
          <Dashboard
            onNavigateToBookings={handleNavigateToBookings}
            onNavigateToTables={handleNavigateToTables}
            onNavigateToCustomer={handleNavigateToCustomers}
          />
        );
      case "customers":
        return <CustomerTable />;
      case "bookings":
        return <BookingTable />;
      case "reports-bookings":
        return <BookingReportDashboard />;
      case "tables":
        return <TableManagement />;
      case "bookings-calendar":
        return <BookingCalendar />;
      case "user-management":
        return <UserManagement />;
      case "settings":
        return <Settings />;
      default:
        return (
          <Dashboard 
            onNavigateToBookings={handleNavigateToBookings}
            onNavigateToTables={handleNavigateToTables}
          />
        );
    }
  };

  return (
    <div className="admin-dashboard">
      {/* Mobile Menu Toggle Button */}
      <button 
        className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={toggleMobileMenu}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Mobile Overlay */}
      <div 
        className={`mobile-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      ></div>

      <Sidebar 
        activeView={activeView} 
        onMenuSelect={handleMenuSelect} 
        onLogout={handleLogout}
        isMobileOpen={isMobileMenuOpen}
        onCloseMobile={closeMobileMenu}
      />
      
      <div className="dashboard-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminDashBoard;